/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROLE } from "../../utils/constants";
import { useFetchData } from "../../customHooks/useGetDashboardData";
import Loader from "../../components/feedBacks/loader";
import { useAppDispatch } from "../../store/hooks";
import { login } from "../../store/authSlice";
import { IUser } from "../../utils/interfaces";
import { ROLE_ACCESS } from "../../routes/AuthGuard";
const API_ROUTE = "users/me";
const PostLogin = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, isLoading, getAccessTokenSilently, logout } =
    useAuth0();
  const [receivedToken, setReceivedToken] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        localStorage.setItem("auth0Token", token);
        setReceivedToken(true);
      } catch (error) {
        console.error("TEstError1 Error while fetching token: ", error);
        logout({
          logoutParams: { returnTo: `${window.location.origin}/auth/login` },
        });
      }
    };

    if (isAuthenticated && !receivedToken) {
      getToken();
    }
  }, [receivedToken, isAuthenticated, getAccessTokenSilently, logout]);

  const {
    data: me,
    isLoading: isUserInfoLoading,
    error: userError,
    isSuccess,
  } = useFetchData(
    [API_ROUTE],
    API_ROUTE,
    {
      login_from: "web_app",
      login_device: navigator.userAgent,
    },
    {
      enabled: !!receivedToken,
      queryKey: [API_ROUTE],
    }
  );

  // Handle navigation after successful user data fetch
  useEffect(() => {
    if (isAuthenticated && !isUserInfoLoading && me != null && isSuccess) {
      try {
        dispatch(login(me as IUser));

        const user = me as IUser;
        const role = user?.access_level;
        const company_id = user?.company_id;

        // Check for returnTo parameter
        const returnTo =
          localStorage.getItem("returnTo") || searchParams.get("returnTo");

        if (returnTo) {
          const intendedDestination = decodeURIComponent(returnTo);

          // Validate that the user has access to the intended destination
          const roleConfig = ROLE_ACCESS[role];

          if (roleConfig) {
            const hasAccess = roleConfig.patterns?.some((pattern: RegExp) =>
              pattern.test(intendedDestination)
            );

            if (hasAccess) {
              // User has access to intended destination, redirect there
              navigate(intendedDestination, { replace: true });
              localStorage.removeItem("returnTo"); // Clear returnTo after use
              return;
            }
          }
        }

        // No returnTo parameter or user doesn't have access to it
        // Redirect to user's default route based on role
        switch (role) {
          case ROLE.ADMIN:
            navigate("/", { replace: true });
            break;
          case ROLE.MANAGER:
            navigate(`/`, { replace: true });
            break;
          case ROLE.FINANCE:
            navigate(`/dashboard/finance/home/${company_id}`, {
              replace: true,
            });
            break;
          case ROLE.OPERATIONS:
            navigate(`/dashboard/operations/home/${company_id}`, {
              replace: true,
            });
            break;
          case ROLE.OTHER:
            navigate("/sbee", { replace: true });
            break;
          default:
            logout({
              logoutParams: {
                returnTo: `${window.location.origin}/auth/login`,
              },
            });
            console.log(
              "TEstError3 User does not have the required role to access the app"
            );
            return;
        }
      } catch (error) {
        console.error("Error during login dispatch:", error);
        logout({
          logoutParams: { returnTo: `${window.location.origin}/auth/login` },
        });
      }
    }
  }, [
    isAuthenticated,
    isUserInfoLoading,
    me,
    isSuccess,
    navigate,
    searchParams,
    dispatch,
    logout,
  ]);

  if (isLoading || !receivedToken || isUserInfoLoading) {
    return <Loader />;
  }

  // Handle errors in fetching user data
  if (userError) {
    logout({
      logoutParams: { returnTo: `${window.location.origin}/auth/login` },
    });
    return <Box>Error fetching user data. Redirecting to login...</Box>;
  }

  if (!isAuthenticated) {
    logout({
      logoutParams: { returnTo: `${window.location.origin}/auth/login` },
    });
    return <Box>I don&apos;t know this user</Box>;
  }

  return <Box>Checking user...</Box>;
};

export default PostLogin;
// headers {'alg': 'dir', 'enc': 'A256GCM', 'iss': 'https://dev-mgw72jpas4obd84e.us.auth0.com/'}
